/* eslint-disable no-useless-escape */
import { useState, useEffect } from "react";
import youtube from "youtube-metadata-from-url";

const useYoutubeData = videoUrl => {
  const [videoData, setVideoData] = useState({});

  useEffect(() => {
    // Avoid metadata request if video is not Youtube
    if (!/^(http:\/\/|https:\/\/)(youtu\.be|www\.youtube\.com)\/([\w\/]+)([\?].*)?$/.test(videoUrl))
      return;

    youtube.metadata(videoUrl).then(
      json => {
        console.log(json);
        setVideoData({ imageUrl: json.thumbnail_url, duration: null });
      },
      err => {
        console.log(err);
      }
    );
  }, [videoUrl]);

  return videoData;
};

export default useYoutubeData;
